// a file to determining weather a user has acess to the givin workout name
export default function hasAcess(serverOrigin, {user, course}) {
	return new Promise((resolve, reject) => {
		if (!user) {
			reject({
				status: 'not logged in',
			});
		}

		let userID = user._id;
		let body = JSON.stringify({
			userID: userID,
			course: course,
		});

		fetch(`${serverOrigin}/hascourse`, {
			method: 'post',
			credentials: 'include',
			headers: {'Content-Type': 'application/json'},
			body: body,
		})
			.then(res => {
				return res.json();
			})
			.then(result => {
				resolve(result);
			})
			.catch(err => {
				console.log(err);
				reject({
					status: 'Course not owned',
				});
			});
	});
}
